import './css/styles.scss';

function kontaktpersonKortInit() {}

kontaktpersonKortInit();
